'use client'

import { useEffect, useState } from 'react'
import ServicesSection from './ServicesSection'
import { useLanguage } from '../../providers/LanguageProvider'

const ServicesFetcher = () => {
  const [data, setData] = useState({ docs: [] })
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `/api/services?locale=${isArabic ? 'ar' : 'en'}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': isArabic ? 'ar' : 'en',
            },
          },
        )
        const result = await res.json()
        setData(result)
      } catch (err) {
        console.error('Failed to fetch services:', err)
      }
    }

    fetchData()
  }, [language])

  return <ServicesSection services={data.docs} />
}

export default ServicesFetcher
